export * from './manifestWriter.service';
export * from './manifestReader.service';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/manifest/index.ts